import type { CustomPacingLineItemError } from '../../../../../apis/graphql';
import { CUSTOM_ERROR_MESSAGES } from '../constants';
import type { ErrorItem } from '../types';

export const mapCustomPacingErrors = (cpErrors: CustomPacingLineItemError[]): ErrorItem[] => {
  const errorItemsMap: Record<string, ErrorItem> = {};

  cpErrors.forEach((error) => {
    let errorItem = errorItemsMap[error.errorCode];

    if (!errorItem) {
      errorItemsMap[error.errorCode] = {
        errorCode: error.errorCode,
        message: CUSTOM_ERROR_MESSAGES[error.errorCode] || error.errorMessage,
        itemIds: [error.lineItemId],
      };
    } else {
      errorItem.itemIds.push(error.lineItemId);
    }
  });

  return Object.values(errorItemsMap);
};
